import { CustomerSummary } from '../api-client';

/**
 * Rows matching a free text search on customer name or sap code.
 *
 * Both sides are lowercased, and the comparison uses includes and not search: the term arrives straight from
 * the input, and search would treat it as a regular expression, so a single "(" would throw and a "." would
 * match anything.
 *
 * A field that is missing never counts as a match. It reads as obvious, but the previous version wrote
 * `entry.sapCode?.search(term) !== -1`: on a row without a sap code the optional chaining returns undefined,
 * and `undefined !== -1` is true, so every row matched and the search looked dead. That is exactly what
 * happened with Impersonate on, where the list came from an endpoint that did not populate sapCode.
 *
 * @param term free text as typed, no need to normalise it beforehand.
 */
export const filterCustomersBySearch = (
	customers: CustomerSummary[] | undefined,
	term?: string,
): CustomerSummary[] => {
	const needle = (term ?? '').trim().toLowerCase();

	if (!needle) return customers ? [...customers] : [];

	return (customers ?? []).filter(
		(entry) =>
			(entry.fullName ?? '').toLowerCase().includes(needle) ||
			(entry.sapCode ?? '').toLowerCase().includes(needle),
	);
};
